module.exports = __webpack_public_path__ + "static/img/3.ca0cae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/hospital/3.png
// module id = bEhK
// module chunks = 1